/**
 * Google Calendar scheduling popup — site-wide (header, homepage, booking page).
 */
(function () {
  var configEl = document.getElementById('google-calendar-popup-config');
  var hiddenTarget = document.getElementById('google-calendar-popup-hidden');
  var bookingRoot = document.getElementById('google-calendar-booking');

  if (!configEl || !hiddenTarget) return;

  var scheduleUrl =
    (bookingRoot && bookingRoot.dataset.scheduleUrl) ||
    configEl.dataset.scheduleUrl ||
    '';
  var buttonColor =
    (bookingRoot && bookingRoot.dataset.buttonColor) ||
    configEl.dataset.buttonColor ||
    '#3f5147';
  var fallbackUrl = configEl.dataset.fallbackUrl || '/pages/book-appointment';
  var hiddenReady = false;
  var hiddenAttempts = 0;

  function getHiddenGoogleButton() {
    var btn = hiddenTarget.nextElementSibling;
    return btn && btn.tagName === 'BUTTON' ? btn : null;
  }

  function setPopupOpen(isOpen) {
    document.documentElement.classList.toggle('google-calendar-popup-open', isOpen);
  }

  function getPopupOverlay() {
    return document.querySelector('.hur54b');
  }

  function isPopupCloseButton(target) {
    return !!(target && target.closest && target.closest('.Xfsokf'));
  }

  function isPopupCalendar(target) {
    return !!(target && target.closest && target.closest('.mmGMM'));
  }

  function shouldBlockPopupDismiss(event) {
    var overlay = getPopupOverlay();
    if (!overlay) return false;

    if (isPopupCloseButton(event.target)) return false;
    if (isPopupCalendar(event.target)) return false;

    return true;
  }

  function blockPopupDismiss(event) {
    if (!shouldBlockPopupDismiss(event)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function blockPopupEscape(event) {
    if (!getPopupOverlay()) return;
    if (event.key !== 'Escape' && event.keyCode !== 27) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function bindPopupDismissGuards() {
    ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown'].forEach(
      function (type) {
        document.addEventListener(type, blockPopupDismiss, true);
      }
    );
    document.addEventListener('keydown', blockPopupEscape, true);
  }

  function hardenGooglePopup() {
    var overlay = getPopupOverlay();
    var frame = document.querySelector('.hur54b .mmGMM, .hur54b iframe');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (overlay) {
      overlay.style.colorScheme = 'light';
    }

    if (!frame) return;

    frame.style.backgroundColor = '#ffffff';
    frame.style.colorScheme = 'light';
    try {
      frame.setAttribute('color-scheme', 'light');
    } catch (error) {
      /* ignore */
    }

    // Mobile: edge-to-edge. Desktop/tablet: leave sizing to Google's script.
    if (isMobile) {
      frame.style.width = '100%';
      frame.style.height = '100%';
      frame.style.maxWidth = 'none';
      frame.style.maxHeight = 'none';
      frame.style.borderRadius = '0';
    } else {
      frame.style.removeProperty('width');
      frame.style.removeProperty('height');
      frame.style.maxWidth = 'calc(100vw - 3rem)';
      frame.style.maxHeight = 'calc(100vh - 3rem)';
      frame.style.borderRadius = '0.5rem';
    }
  }

  function watchGooglePopup() {
    var observer = new MutationObserver(function () {
      var isOpen = !!document.querySelector('.hur54b');
      setPopupOpen(isOpen);
      if (isOpen) hardenGooglePopup();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', function () {
      if (document.querySelector('.hur54b')) hardenGooglePopup();
    });
  }

  function initHiddenPopup() {
    if (hiddenReady || !scheduleUrl) return;

    if (!window.calendar || !window.calendar.schedulingButton) {
      hiddenAttempts += 1;
      if (hiddenAttempts < 50) {
        window.setTimeout(initHiddenPopup, 150);
      }
      return;
    }

    hiddenTarget.innerHTML = '';
    window.calendar.schedulingButton.load({
      url: scheduleUrl,
      color: buttonColor,
      label: 'Book an appointment',
      target: hiddenTarget,
    });
    hiddenReady = true;
  }

  function openPopup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var googleBtn = getHiddenGoogleButton();
    if (googleBtn) {
      googleBtn.click();
      return;
    }

    window.location.href = fallbackUrl;
  }

  function isPopupTrigger(element) {
    if (!element || !element.closest) return null;
    return element.closest('[data-gcal-popup-trigger]');
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = isPopupTrigger(event.target);
      if (!trigger) return;
      openPopup(event);
    },
    true
  );

  watchGooglePopup();
  bindPopupDismissGuards();

  if (document.readyState === 'complete') {
    initHiddenPopup();
  } else {
    window.addEventListener('load', initHiddenPopup);
  }
})();
